var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmailCircle = function SvgEmailCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_363_2459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2004 17.4H7.40039C6.29582 17.4 5.40039 16.5045 5.40039 15.4V10.0333V9.19995C5.40039 8.09538 6.29582 7.19995 7.40039 7.19995H17.2004C18.305 7.19995 19.2004 8.09538 19.2004 9.19995V10.0333V15.4C19.2004 16.5045 18.305 17.4 17.2004 17.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.40039 10.0333V9.19995C5.40039 8.09538 6.29582 7.19995 7.40039 7.19995H17.2004C18.305 7.19995 19.2004 8.09538 19.2004 9.19995V10.0333M5.40039 10.0333V15.4C5.40039 16.5045 6.29582 17.4 7.40039 17.4H17.2004C18.305 17.4 19.2004 16.5045 19.2004 15.4V10.0333M5.40039 10.0333L11.4164 12.9977C11.9737 13.2723 12.6271 13.2723 13.1844 12.9977L19.2004 10.0333",
    stroke: "#838383"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clip-path", {
    id: "clip0_363_2459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmailCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/email-circle.e7c78a3412cd29663ca16f495c3a1427.svg";